import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadChildren: async () => (await import('./auth/auth.module')).AuthModule,
    data: { title: 'UGOL SKETCH.Авторизация' },
  },
//   {
//     path: 'account',
//     canActivate: [AuthGuard],
//     loadChildren: async () => (await import('./account/account.module')).AccountModule,
//     data: { title: 'UGOL SKETCH.Личный кабинет' },
//   },
{
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadChildren: async () => (await import('./dashboard/dashboard.module')).DashboardModule,
    data: { title: 'UGOL SKETCH.Дашборд' },
  },
  {
    path: 'sketch',
    canActivate: [AuthGuard],
    loadChildren: async () => (await import('./sketch/sketch.module')).SketchModule,
    data: { title: 'UGOL SKETCH.Дизайн' },
  },
//   { path: '**', component: NoFoundComponent },
];
